import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "How much will BizBinder cost?",
    a: "We're still finalising pricing. Everyone who joins the waitlist gets our launch-day pricing details first — including any early-access discount. Whatever we settle on, our promise is: no dark patterns, and you'll always be able to export your data.",
  },
  {
    q: "When will it be on the App Store and Play Store?",
    a: "Next month, on both stores. Join the waitlist above and you'll get the download link on launch day.",
  },
  {
    q: "Do I have to be running a business?",
    a: "Business owners are our primary audience, but BizBinder is designed for anyone with a growing contact list — freelancers, recruiters, insurance agents, students, community organizers, even individuals who just want their phonebook to make sense.",
  },
  {
    q: "How does the post-call voice reminder work?",
    a: "When a call you started through BizBinder ends, the app opens a small note window with the contact already selected. Type your note, tap a quick-time chip (15 min, 30 min, 1 hr, Tomorrow 9 AM), or hold the mic and speak — the assistant transcribes the note and detects when to remind you.",
  },
  {
    q: "Will it work with my existing phone contacts?",
    a: "Yes. You can import contacts from your phone with one tap, upload a CSV, or scan business cards. Phone numbers are automatically normalised and duplicates are detected for you.",
  },
  {
    q: "Can I sync across my phone and tablet?",
    a: "Yes. Your groups, notes, and reminders sync securely to the cloud so your data is available on every signed-in device.",
  },
  {
    q: "Can I export my data if I ever leave?",
    a: "Always. One-tap CSV export from any screen. You can also delete your account — and all your data — from settings, any time.",
  },
  {
    q: "Does it have a dark mode?",
    a: "Light, dark, and system — pick one in settings. The app matches your phone's theme by default.",
  },
];

export default function FAQ() {
  return (
    <section className="relative py-24 md:py-32 border-t border-black/5" data-testid="faq-section">
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <div className="overline mb-4">FAQ</div>
          <h2 className="font-display text-4xl md:text-5xl font-medium leading-[1.02] tracking-tight text-[color:var(--ink)]">
            Questions,
            <span className="gradient-text" style={{ fontFamily: "var(--font-serif)", fontStyle: "italic" }}>
              {" "}
              answered.
            </span>
          </h2>
          <p className="mt-6 text-[color:var(--ink-soft)] max-w-sm">
            Still curious?{" "}
            <a href="#waitlist" className="text-[color:var(--accent)] link-underline">Drop us your email</a>{" "}
            and we&apos;ll reply directly.
          </p>
        </div>

        <div className="md:col-span-8">
          <Accordion type="single" collapsible className="border-t border-black/10" data-testid="faq-accordion">
            {faqs.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-b border-black/10"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="text-left py-6 text-[color:var(--ink)] text-lg md:text-xl font-display font-medium hover:no-underline">
                  <span className="flex items-baseline gap-4">
                    <span className="text-[color:var(--ink-mute)] text-xs font-mono">{String(i + 1).padStart(2, "0")}</span>
                    <span>{f.q}</span>
                  </span>
                </AccordionTrigger>
                <AccordionContent className="text-[color:var(--ink-soft)] text-base leading-relaxed pb-8 pl-10 max-w-2xl">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
